import React from "react";
import styled from "styled-components";
import {
    SectionHeadline
  } from '../styled';

const Container = styled.div`
    padding: 80px 25px;
    margin: 0 auto 50px;
    display: flex;
    justify-content: center;
    background-color: #F1F3F9;
    align-items: center;
    flex-direction: column;
`

const Iframe = styled.iframe`
    width: 500px;
    height: 100%;
    border: none;
    height: 620px;
    margin-top: 50px;
    @media (max-width: 768px) {
        width: 340px;
    }
`

function HomepageTnf ({input}) {
    const { primary } = input
    return (
        <Container>
            <SectionHeadline>{primary.title.text}</SectionHeadline>
            <Iframe
            title="attestation-iframe"
            src="https://widget.real-time-reserves.ledgerlens.io/v1/tusd"
            />
        </Container>
    )
}

export { HomepageTnf }